import { BrandLogo } from '@/components/brand/Brand';
import { Button } from '@/components/ui/Button';
import { errorMessage } from '@/lib/api/errors';
import { useAuth } from '@/lib/auth/AuthContext';
import styles from './BootSplash.module.css';

export function BootSplash() {
  const { bootError, retryBoot } = useAuth();

  return (
    <div className={styles.splash} role="status" aria-live="polite">
      <BrandLogo height={88} />

      {bootError ? (
        /**
         * The session is still presumed valid — the app just could not confirm it. Saying
         * "não conseguimos falar com o servidor" and retrying is the truthful move; bouncing
         * to the login screen would imply the user was signed out, which they were not.
         */
        <>
          <p className={styles.tagline}>{errorMessage(bootError)}</p>
          <p className={styles.retryNote}>Tentando de novo automaticamente.</p>
          <Button variant="onInk" size="sm" onClick={retryBoot}>
            Tentar agora
          </Button>
        </>
      ) : (
        /* A tagline saiu do texto porque agora ela está desenhada no logo — "PLAY. TRACK.
           IMPROVE." logo acima. Duas promessas empilhadas diluiriam as duas. */
        <span className="visually-hidden">Carregando</span>
      )}
    </div>
  );
}
